var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsxexport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.305,
    height: 34,
    viewBox: "0 0 29.305 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13585",
    "data-name": "Group 13585",
    transform: "translate(-10121.348 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_63_8",
    "data-name": "Component 63 \\u2013 8",
    transform: "translate(10121.348 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xls",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M31.283,8.713,24.241,1.671A.55.55,0,0,0,23.83,1.5H6.763A2.284,2.284,0,0,0,4.5,3.767V14.983a.586.586,0,0,0,1.172,0V3.767A1.091,1.091,0,0,1,6.763,2.676H23.255V9.117a.586.586,0,0,0,.586.586h6.446V33.227A1.091,1.091,0,0,1,29.2,34.318H6.763a1.091,1.091,0,0,1-1.091-1.091V30.222a.586.586,0,0,0-1.172,0v3.013A2.284,2.284,0,0,0,6.763,35.5H29.2a2.284,2.284,0,0,0,2.263-2.263V9.117A.55.55,0,0,0,31.283,8.713Zm-6.852-5.2,5.025,5.036H24.427Z",
    transform: "translate(-2.155 -1.5)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M27.115,24.323V16.4a1.888,1.888,0,0,0-1.9-1.9H4.4a1.888,1.888,0,0,0-1.9,1.9v7.923a1.888,1.888,0,0,0,1.9,1.9H25.216a1.888,1.888,0,0,0,1.9-1.9Z",
    transform: "translate(-2.5 0.741)",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_18677",
    "data-name": "Path 18677",
    d: "M0,0,1.957-2.988.184-5.727H1.535l1.148,1.84,1.125-1.84h1.34L3.367-2.945,5.324,0H3.93L2.66-1.98,1.387,0ZM6.26,0V-5.68H7.416V-.965h2.875V0Zm4.873-1.863,1.125-.109a1.372,1.372,0,0,0,.412.832,1.246,1.246,0,0,0,.838.266,1.288,1.288,0,0,0,.842-.236.7.7,0,0,0,.283-.553.521.521,0,0,0-.119-.346.952.952,0,0,0-.416-.248q-.2-.07-.926-.25a3.141,3.141,0,0,1-1.3-.566,1.49,1.49,0,0,1-.527-1.152,1.472,1.472,0,0,1,.248-.818,1.553,1.553,0,0,1,.715-.58,2.865,2.865,0,0,1,1.127-.2,2.417,2.417,0,0,1,1.623.473,1.668,1.668,0,0,1,.572,1.262l-1.156.051a.982.982,0,0,0-.318-.635,1.166,1.166,0,0,0-.732-.193,1.321,1.321,0,0,0-.789.207.417.417,0,0,0-.184.355.44.44,0,0,0,.172.348,3.04,3.04,0,0,0,1.063.383,5.607,5.607,0,0,1,1.248.412,1.608,1.608,0,0,1,.633.582,1.7,1.7,0,0,1,.229.912,1.686,1.686,0,0,1-.273.922,1.639,1.639,0,0,1-.773.639A3.243,3.243,0,0,1,13.5.1a2.481,2.481,0,0,1-1.668-.5A2.183,2.183,0,0,1,11.133-1.863ZM16.49,0l1.957-2.988L16.673-5.727h1.352l1.148,1.84L20.3-5.727h1.34L19.857-2.945,21.814,0H20.419L19.15-1.98,17.877,0Z",
    transform: "translate(10123 -360)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxexport);
export default __webpack_public_path__ + "static/media/xlsxexport.fa100caa.svg";
export { ForwardRef as ReactComponent };